export enum SIZE_CLASS {
  SMALL = 'col-sm-3',
  MEDIUM = 'col-sm-4',
  LARGE = 'col-sm-6',
  CUSTOM = 'fix-size',
}

export enum SIZE {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  CUSTOM = 'CUSTOM',
}

export interface OwnProps {
  size: string
  title?: string
  icon?: string
  value?: number
  customClass?: string
  style?: any
}

export type Props = OwnProps
